import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CommunicationServiceService {

  private scrumBoardData = new Subject<any>();
  private searchInput = new Subject<string>();
  private taskCount = new Subject<number>();
  private milestoneRefresh = new Subject<boolean>();

  constructor() { }

  setScrumBoardData(data: any) {
    this.scrumBoardData.next(data);
  }

  getScrumBoardData(): Observable<any> {
    return this.scrumBoardData.asObservable();
  }

  setSearchInput(data: any) {
    this.searchInput.next(data);
  }

  getSearchInput(): Observable<any> {
    return this.searchInput.asObservable();
  }

  setTaskCount(count: number) {
    this.taskCount.next(count);
  }

  getTaskCount(): Observable<number> {
    return this.taskCount.asObservable();
  }

  // Milestone refresh methods
  setMilestoneRefresh(refresh: boolean = true) {
    this.milestoneRefresh.next(refresh);
  }

  getMilestoneRefresh(): Observable<boolean> {
    return this.milestoneRefresh.asObservable();
  }
}
